import util from '../util'

let controller = 'HistoricoPortabilidade'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
})